goog.provide('el8.ptdata.xmlSummaries');

goog.require('el8.model.base');
goog.require('el8.service.urls');

/**
 * This document backs a chart feed item for a CCD/C-CDA/other XML upload,
 * which can be imported if we can parse it
 */
el8.ptdata.xmlSummaries = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addStringProperty('downloadUrl'); // to get back the raw XML
    _class.addStringProperty('validateUrl'); // to validate the xml for format errors
    _class.addStringProperty('authorName');

    _class.addBoolean('demographicsImported');
    _class.addBoolean('allergiesImported');
    _class.addBoolean('encountersImported');
    _class.addBoolean('immunizationsImported');
    _class.addBoolean('labsImported');
    _class.addBoolean('medicationsImported');
    _class.addBoolean('problemsImported');
    _class.addBoolean('proceduresImported');
    _class.addBoolean('vitalsImported');

    _class.addIntProperty('dataFormat');


    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.isQRDA_1 = function() {
        return this.getDataFormat() === 3;
    };

    _class.prototype.isCCR = function() {
        return this.getDataFormat() === 2;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        delete mapped['signUserBehalfId'];
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();

        mapped['signUserType'] = this.getSignUserType();

        mapped['isQRDA_1'] = this.isQRDA_1();
        mapped['isCCR'] = this.isCCR();

        return mapped;
    };

    _class.prototype.sign = function(opts) {
        opts = opts || {};
        var postDict = {};
        if (!el8.util.isNone(opts.doImport)) { postDict.do_import = opts.doImport; }
        if (!el8.util.isNone(opts.behalfUserId)) { postDict.behalf_user_id = opts.behalfUserId; }

        $.el8_ajax({
            type: 'POST',
            data: JSON.stringify(postDict),
            url: el8.service.urls.get('signXmlSummary', [this]),
            success: function(data) {
                var updatedSummary = that.create(data.xml_summary);
                if (opts.successCb) { opts.successCb(updatedSummary, data); }
            },
            complete: function() {
                if (opts.completeCb) { opts.completeCb(); }
            }
        });
    };

    return that;

})();
